<template>
  <div id="survey-form-page">
    <!-- 섹션 단위 프레임 START -->
    <v-card
      :class="`${
        $vuetify.breakpoint.smAndDown ? 'elevation-0' : 'elevation-10'
      }`"
    >
      <!--  페이지 타이틀 START -->
      <v-card-title
        v-if="properties.survey.forms.formFormat == 'STEP_BY_SECTION'"
        primary-title
        class="justify-left"
      >
        <span :class="styles.sectionTitle"
          ><strong>{{
            properties.currentFormSection.sectionTitle
          }}</strong></span
        >
      </v-card-title>
      <!-- 시작 페이지 타이틀 END -->
      <v-divider
        v-if="properties.survey.forms.formFormat == 'STEP_BY_SECTION'"
      ></v-divider>
      <!-- 시작 페이지 설명 START -->
      <v-card-text
        v-if="properties.survey.forms.formFormat == 'STEP_BY_SECTION'"
        class="justify-center"
      >
        <pre class="form-object-text-content">{{
          properties.currentFormSection.sectionDescription
        }}</pre>
      </v-card-text>
      <div
        :class="
          properties.survey.forms.formFormat == 'STEP_BY_SECTION' ? 'ma-4' : ''
        "
        v-for="(fo, i) in formObjects"
        :key="fo.formObjectId"
      >
        <rs-form-object
          :formObject="fo"
          :formFormat="properties.survey.forms.formFormat"
          :responseAnswers="properties.currentFormSection.responseAnswers"
          :objectValues.sync="objectValues[i]"
          :ref="fo.formObjectId"
          :themeColor="themeColor"
        ></rs-form-object>
      </div>
      <!-- 시작 페이지 설명 END -->
      <!-- 액션 영역 START -->
      <v-scale-transition>
        <div>
          <v-divider></v-divider>
          <v-card-actions class="mt-5">
            <v-spacer></v-spacer>
            <v-btn
              v-if="canMovePrevious"
              width="140"
              max-width="300"
              large
              class="text-h6 mb-4 rounded-lg mr-2"
              @click="$emit('previous')"
              ><strong>{{ $t("이전") }}</strong>
            </v-btn>
            <v-btn
              v-if="isValid"
              width="140"
              max-width="300"
              large
              :color="themeColor"
              dark
              class="text-h6 mb-4 rounded-lg"
              @click="saveQuestionAnswer"
              ><strong>{{ $t("다음") }}</strong>
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </div>
      </v-scale-transition>
      <!-- 액션 페이지 타이틀 END -->
    </v-card>
    <!-- 섹션 단위 프레임 END -->
  </div>
</template>

<script>
import { $createQuestionAsnwer } from "@/redsurvey/api/survey";
import RsFormObject from "@/redsurvey/components/survey/objects/RsFormObject";
export default {
  components: {
    // RsFormSection,
    RsFormObject,
  },
  props: {
    targetKey: {
      type: String,
    },
    rid: {
      type: String,
      required: true,
    },
    properties: {
      type: Object,
      required: true,
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
    pagePath: {
      type: Array,
      default: () => [],
    },
    themeColor: {
      type: String,
      default: "primary"
    }
  },
  computed: {
    styles() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return {
            pageTitle: "text-h6",
            sectionTitle: "text-subtitle-1",
            description: "text-subtitle-1 content-description mx-5",
          };
        default:
          return {
            pageTitle: "text-h5",
            sectionTitle: "text-h6",
            description: "text-subtitle-1 content-description mx-5",
          };
      }
    },
    questionAnswers() {
      // 문항 형식 답변 필터링
      let ovs = this.objectValues.filter((ov) => ov.objectType == "QUESTION");
      let answers = [];
      ovs.forEach((q) => {
        if (q.values) {
          if (Array.isArray(q.values)) {
            q.values.forEach((v) => {
              answers.push(v);
            });
          } else {
            answers.push(q.values);
          }
        }
      });
      return answers;
    },
    isValid() {
      return this.objectValues.every((ov) => ov.isValid);
    },
    nextPage() {
      let nextPage = null;
      const ovs = this.objectValues;

      if (this.properties.survey.forms.formFormat == "STEP_BY_SECTION") {
        // 1. 폼 유형이 섹션 타입인 경우
        // 1.1 해당 섹션의 nextPage를 기본 값으로 설정
        ovs.forEach((ov) => {
          if(nextPage == null && ov.nextPage != null && ov.nextPage != "NOT_SET")  {
            nextPage = ov.nextPage;
          }

        });
        // NEXT SUBMIT 일반 값의 최촛 값 설정
        // null / NOT_SET은 패스
         if( nextPage == null) {
           nextPage = this.properties.currentFormSection.nextPage;
          }
      } else {
        // TODO: 1.2 각 문항의 옵션 값에 선택에 따른 nextPage값이 있는 경우 해당 값으로 nextPage설정
        // TODO: 1.2.1. nextPage값이 여러 문항에서 설정되는 경우 최 우선 순위는 가장 먼저 설정된 분기값으로 설정 됨.
        if (ovs.length > 0) {
          nextPage = ovs[0].nextPage;
        }
      }

      return nextPage;
    },
    canMovePrevious() {
      if (this.isPreview) {
        // 미리보기는 부모가 메모리에서 관리하는 경로를 사용
        return this.pagePath.length > 1;
      } else {
        // 실제 설문은 RS_SURVEY_RESPONSE.PAGE_PATH를 사용
        return (
          JSON.parse(this.properties.surveyResponse.pagePath || "[]").length > 1
        );
      }
    },
  },
  data() {
    return {
      formObjects: Object.assign(
        [],
        this.properties.currentFormSection.formObjects
      ),
      objectValues: [],
    };
  },
  methods: {
    async saveQuestionAnswer() {
      //isvalid 체크
      const refs = this.$refs;
      let ovs = this.objectValues.filter((ov) => ov.objectType == "QUESTION");
      await ovs.forEach((v) => {
        refs[v.formObjectId][0].checkValidation();
      });

      if (this.isValid == true) {
        //questionVal수집
        const params = {
          k: this.targetKey,
          r: this.rid,
          nextPage: this.nextPage,
          questionAnswers: this.questionAnswers,
        };
        this.$emit("loading", true);
        try {
          const surveyId = this.properties.survey.surveyId;
          if(this.isPreview) {
            this.$emit("next", "IN_PROGRESS", this.nextPage);
          } else {
            const { data } = await $createQuestionAsnwer(surveyId, params);
            this.$emit("next", data.result);
          }
        } catch (e) {
          this.$rxSnackbar("error", this.$t("common.msg.unexpected_error"));
        } finally {
          this.$emit("loading", false);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.form-object-text-content {
  // line-break: auto;
  white-space: pre-wrap;
  font-family: SUIT;
  font-weight: 400;
}
</style>